"use strict";

var _regeneratorRuntime = require("/codebuild/output/src2552594638/src/corporate_sites/node_modules/@babel/runtime/regenerator/index.js");
function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, t) {
  for (var a = 0; a < t.length; a++) {
    var n = t[a];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
  }
}
function _createClass(e, t, a) {
  return t && _defineProperties(e.prototype, t), a && _defineProperties(e, a), e;
}
function asyncGeneratorStep(e, t, a, n, r, i, s) {
  try {
    var o = e[i](s),
      c = o.value;
  } catch (e) {
    return void a(e);
  }
  o.done ? t(c) : Promise.resolve(c).then(n, r);
}
function _asyncToGenerator(e) {
  return function () {
    var t = this,
      a = arguments;
    return new Promise(function (n, r) {
      var i = e.apply(t, a);
      function s(e) {
        asyncGeneratorStep(i, n, r, s, o, "next", e);
      }
      function o(e) {
        asyncGeneratorStep(i, n, r, s, o, "throw", e);
      }
      s(void 0);
    });
  };
}
var axios = require("axios"),
  BackendService = require("./../Backend.service");
function numberWithCommas(e) {
  return e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function getDisplayStatus4Local(e) {
  for (var t = e.split(""), a = t.length, n = [], r = 0; r < a; r++) {
    var i = t[r];
    0 !== r && i === i.toUpperCase() && n.push(r);
  }
  return n.forEach(function (e) {
    return t.splice(e, 0, " ");
  }), e = t.join("");
}
function formatDate(e) {
  var t = new Date(e),
    a = "" + (t.getMonth() + 1),
    n = "" + t.getDate(),
    r = t.getFullYear();
  return a.length < 2 && (a = "0" + a), n.length < 2 && (n = "0" + n), [a, n, r].join("/");
}
function getApplicationStatusLocal(e) {
  return _getApplicationStatusLocal.apply(this, arguments);
}
function _getApplicationStatusLocal() {
  return (_getApplicationStatusLocal = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
    var a,
      n,
      r,
      i,
      s,
      o,
      c,
      u,
      l,
      p,
      m,
      f,
      g,
      _,
      d,
      b,
      y,
      h,
      v,
      w,
      S = arguments;
    return _regeneratorRuntime.wrap(function (e) {
      for (;;) switch (e.prev = e.next) {
        case 0:
          return a = S.length > 1 && void 0 !== S[1] && S[1], n = S.length > 2 ? S[2] : void 0, r = "No", i = "Not Applicable", s = "DUMMY-SE2-REF", o = {}, c = !1, u = (u = t.split("-"))[0], e.next = 11, BackendService.getAppData(u);
        case 11:
          return l = e.sent, l = (l = JSON.parse(l.Payload)).body, p = {
            policyNumber: "BT00000000"
          }, m = "paclife_".concat(t).split("-").join("_"), l[m] ? (p = l[m], console.log("getApplicationStatus:In multiple application"), s = l[m].clientId) : l.paclifeTicket && (p = l.paclifeTicket, console.log("getApplicationStatus:In single application"), s = l.paclifeTicket.clientId), f = {
            policyNumber: p.policyNumber
          }, a && (f = {
            policyNumber: "BT00051210"
          }), g = BackendService.getPaclifeURL(n), e.next = 23, axios({
            method: "post",
            url: g + "/paclife/policy-status",
            data: f
          });
        case 23:
          if ((_ = e.sent).data.code && 400 == _.data.code && (c = !0), d = {
            status_count: 0
          }, b = [], _.data.history) for (b = _.data.history, y = 0; y < b.length; y++) d.status_count = y + 1, h = getDisplayStatus4Local(b[y].status), d["status_" + (y + 1)] = {
            display_status_name: h,
            status_name: b[y].status,
            status_date: formatDate(b[y].timestamp),
            status_message: b[y].description,
            status_event: b[y].event,
            status_progress: "completed"
          }, r = "No" === r && "Active" === b[y].event ? "Yes" : r, i = "No" === r ? "/appstatus?appid=".concat(t) : "Not Applicable";
          0 == b.length && (v = new Date(), d.status_count = 1, d.status_1 = {
            status_name: "Application Submitted",
            status_event: "PendingSignatures",
            status_date: formatDate(v),
            status_message: "Application received. Pending signatures.",
            status_progress: "completed"
          }, r = "No", i = "/appstatus?appid=".concat(t)), console.log("paclifeAppStatus: ", d);
          try {
            w = numberWithCommas(w = l.paclifeQuote.faceAmount), o = [{
              se2_reference: s,
              created_at: l.createdAt,
              app_status_url_part2: i,
              is_policy_active: r,
              carrier_logo: "https://public-bubble.s3-us-west-2.amazonaws.com/images/next-by-pacific-life-1-tf2y4k.png.png",
              carrier_title: "NEXT Term Life",
              carrier_sub_title: l.paclifeQuote.riskClass,
              quote_amount_value: "$" + l.paclifeQuote.premiumAmount,
              quote_amount_unit: "mo",
              policy_number: p.policyNumber,
              insured_details: {
                insured_name: l.comfirmDetailsFirstName + " " + l.comfirmDetailsLastName,
                gender: l.paclifeQuote.gender,
                age: l.paclifeQuote.issueAge + " years old",
                coverage_amount: "$" + w
              },
              download_url: "https://public-bubble.s3-us-west-2.amazonaws.com/images/next-by-pacific-life-1-tf2y4k.png.png",
              details: {
                title: "Overall Progress",
                sub_title: "See where your application is right now",
                application_status: d
              },
              hasError: c
            }];
          } catch (e) {
            o = [{
              carrier_logo: "https://public-bubble.s3-us-west-2.amazonaws.com/images/next-by-pacific-life-1-tf2y4k.png.png",
              carrier_title: "NEXT Term Life",
              carrier_sub_title: "",
              quote_amount_value: "$0",
              quote_amount_unit: "mo",
              policy_number: p.policyNumber,
              insured_details: {
                insured_name: "",
                gender: "",
                age: "",
                coverage_amount: "$0"
              },
              download_url: "https://public-bubble.s3-us-west-2.amazonaws.com/images/next-by-pacific-life-1-tf2y4k.png.png",
              details: {
                title: "Overall Progress",
                sub_title: "See where your application is right now",
                application_status: d
              },
              hasError: !0
            }];
          }
          return e.abrupt("return", o);
        case 32:
        case "end":
          return e.stop();
      }
    }, e);
  }))).apply(this, arguments);
}
var AppFlowHelper = function () {
  return _createClass(function e(t) {
    _classCallCheck(this, e), this.envObject = t;
  }, [{
    key: "getApplicationStatus",
    value: (e = _asyncToGenerator(_regeneratorRuntime.mark(function e(t) {
      var a,
        n = arguments;
      return _regeneratorRuntime.wrap(function (e) {
        for (;;) switch (e.prev = e.next) {
          case 0:
            return a = n.length > 1 && void 0 !== n[1] && n[1], e.abrupt("return", getApplicationStatusLocal(t, a, this.envObject));
          case 2:
          case "end":
            return e.stop();
        }
      }, e, this);
    })), function (t) {
      return e.apply(this, arguments);
    })
  }]);
  var e;
}();
module.exports = {
  AppFlowHelper: AppFlowHelper
};